import React, { useState } from 'react';

import './UserFilter.css'


const UserFilter = ({ onFilter }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter({ name, description
     });
  };
  return (
    <form onSubmit={handleSubmit} className="row g-3">
      <div className="col-md-4">
        <label htmlFor="name" className="form-label">
        Kategória Neve:
        </label>
        <input
          type="text"
          id="name"
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Keresés név szerint"
        />
      </div>
            
      <div className="col-md-4">
        <label htmlFor="description" className="form-label">
          Leírás:
        </label>
        <input
          type="text"
          id="description"
          className="form-control"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Keresés leírás szerint"
        />
        
      </div>
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary">
          Szűrés
        </button>
      </div>
    </form>
  );
  
}

export default UserFilter;
